import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { toast } from "sonner";

export default function MessagesPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/messages", { params: { limit: 50 } });
      setItems(data.items);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    try { await api.post(`/messages/${id}/read`); load(); }
    catch (e) { toast.error("Failed"); }
  };

  return (
    <div className="max-w-3xl">
      <div className="mb-6">
        <div className="label-overline">Account</div>
        <h1 className="text-3xl font-black tracking-tight mt-1">Messages</h1>
        <p className="text-slate-600 text-sm mt-1">Notices from the platform: billing, updates, warnings.</p>
      </div>

      <div className="bg-white border border-slate-200">
        {loading && <div className="px-4 py-6 text-center text-slate-500">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="px-4 py-6 text-center text-slate-500">You have no messages.</div>
        )}
        <div className="divide-y divide-slate-100">
          {items.map((m) => (
            <div key={m.id}
                 data-testid={`msg-item-${m.category}`}
                 className={`px-4 py-3 ${m.read ? "opacity-70" : "bg-blue-50/30"}`}>
              <div className="flex items-center gap-2 text-xs">
                <span className="pill" style={{
                  borderColor: m.severity === "critical" ? "#DC2626"
                    : m.severity === "warning" ? "#EAB308" : "#2563EB",
                  color: m.severity === "critical" ? "#DC2626"
                    : m.severity === "warning" ? "#A16207" : "#2563EB",
                }}>{m.severity}</span>
                <span className="font-mono text-slate-500">{m.category}</span>
                <span className="ml-auto font-mono text-slate-500">{fmtDate(m.created_at)}</span>
              </div>
              <div className="mt-1 font-semibold">{m.title}</div>
              <div className="text-sm text-slate-700 whitespace-pre-wrap">{m.body}</div>
              {!m.read && (
                <button data-testid={`msg-read-${m.id}`} onClick={() => markRead(m.id)}
                        className="mt-2 text-xs text-blue-700 hover:underline">Mark as read</button>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
